import { CheckProjectAccessFACCProps, CheckProjectAccessProps } from ".";
import { useCheckProjectAccess } from "../../../hooks/utils/useCheckProjectAccess";
import { RequiredPermissionsPopOver } from "../RequiredPermissionsPopOver";

export function CheckProjectAccess<
    F extends CheckProjectAccessFACCProps = CheckProjectAccessFACCProps
>({
    children,
    projectId,
    userId,
    orgId,
    any,
    roles,
    hideChildrenIfNoAccess = false,
    ...props
}: Readonly<CheckProjectAccessProps<F>>) {
    const { hasAccess, mergedPermissions } = useCheckProjectAccess({
        projectId,
        orgId,
        userId,
        requiredPermissions: props,
        any,
        roles
    });
    if (typeof children === 'function') {
        return children({ ...mergedPermissions as F, hasAccess })
    }
    if (!hasAccess && hideChildrenIfNoAccess) {
        return null;
    }
    if (hasAccess) {
        return <>{children}</>
    }
    return (
        <RequiredPermissionsPopOver requiredPermissions={Object.keys(props)} any={any} roles={roles}>
            {children}
        </RequiredPermissionsPopOver>
    )
}